import { Route, Navigate } from "react-router-dom";
import { REDIRECTS } from "@/lib/redirects";

/**
 * Returns one <Route> element per entry in the REDIRECTS map.
 * Mount the result inside <Routes> in App.tsx, above the catch-all "*" route.
 *
 * Note: this is a function (not a component) because <Routes> only accepts
 * <Route> children directly — not wrapping components.
 */
export function legacyRedirectRoutes() {
  return Object.entries(REDIRECTS).map(([from, to]) => (
    <Route key={from} path={from} element={<Navigate to={to} replace />} />
  ));
}
